import { render, staticRenderFns } from "./RewardsInput.vue?vue&type=template&id=05fe54df&scoped=true&"
import script from "./RewardsInput.vue?vue&type=script&lang=js&"
export * from "./RewardsInput.vue?vue&type=script&lang=js&"
import style0 from "./RewardsInput.vue?vue&type=style&index=0&id=05fe54df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fe54df",
  null
  
)

export default component.exports